import r from "./generateUtilityClasses.mjs";
import t from "./generateUtilityClass.mjs";
function a(e) {
  return t("MuiPickersYear", e);
}
const o = r("MuiPickersYear", ["root", "yearButton", "selected", "disabled"]);
export {
  a as getPickersYearUtilityClass,
  o as pickersYearClasses
};
//# sourceMappingURL=pickersYearClasses.mjs.map
